export const useRoles = () => {
	const splitRoles = (role) => {
		const roleSplit = role.split(":");

		if (roleSplit.length === 2)
			return {
				page: roleSplit[0],
				action: roleSplit[1],
			};
		else if (roleSplit.length === 3)
			return {
				page: roleSplit[0],
				component: roleSplit[1],
				action: roleSplit[2],
			};
	};
	return [splitRoles];
};

export const isGYUser = roles => roles.includes("_GY:Base");

export const isAcctUser = roles => roles.includes('_GY:Accounting');

export const isGYTHUser = roles => roles.includes("_GY:TH");

export const isGYVNUser = roles => roles.includes("_GY:VN");

export const isGYKHUser = roles => roles.includes("_GY:KH");

export const isGYPHUser = roles => roles.includes("_GY:PH");

export const isITUser = roles => roles.includes("_GY:IT");

export const isOMUser = roles => roles.includes("_GY:O&M");

export const isManagementUser = roles => roles.includes("_GY:Management");

// export const isClientHQUser = roles => roles.includes("_CLIENT:HQ");
export const isClientHQUser = (userInfo) => userInfo && userInfo.site_id === 'all' && userInfo.client_id !== 'all';

export const isClientTHUser = roles => roles.includes("_CLIENT:TH");

export const isClientVNUser = roles => roles.includes("_CLIENT:VN");

export const isClientUser = roles => roles.includes("_CLIENT:Base");

export const isMakroClientUser = userInfo => userInfo && userInfo.client_id === '18';

export const isAbleToSendEmailTH = roles => roles.includes("administration:InvoiceTable:_sendInvoice-TH");

export const getGYUserCountry = roles => {
	if(isGYTHUser(roles)) return 'TH';
	if(isGYVNUser(roles)) return 'VN';
	if(isGYKHUser(roles)) return 'KH';
	if(isGYPHUser(roles)) return 'PH';
	return null;
}